import React from 'react';
import {
  Section,
  InformativeTag,
  ActionButton,
  Body,
  Tooltip,
  LoadingShimmer
} from '@icarros/ids-react';
import {
  BodyWrapper,
  ResumeDifferentialsWrapper,
  ResumeTitleWrapper,
  ResumeVehicleDifferentialsList,
  TitleWithTooltip
} from './style';
import { useAdContext } from '../../../store/contexts/ad';
import { EDIT_ROUTES } from '../../../utils/adEditRoutes';
import { useAd } from '../../../store/hooks/useAd';
import { pushSellerPFDashboardEvent } from '../../../../utils/pushToDataLayer';

export function VehicleDifferentials(): JSX.Element {
  const { currentAd } = useAdContext();
  const { pushToEditForm } = useAd();

  const { itensDescricao } = currentAd?.veiculo || {
    itensDescricao: [
      { id: 999, nome: 'loading' },
      { id: 1000, nome: 'loading' }
    ]
  };

  return (
    <ResumeDifferentialsWrapper>
      <ResumeTitleWrapper>
        <TitleWithTooltip>
          <Section size="section_1">diferenciais do veículo</Section>
          {currentAd && !itensDescricao && (
            <Tooltip>Características que tornam seu veículo mais atrativo.</Tooltip>
          )}
        </TitleWithTooltip>

        <ActionButton
          iconName="itaufonts_educacao_uso_consc"
          text="editar"
          variant="secondary"
          weight="small"
          onClick={() => {
            pushSellerPFDashboardEvent('diferenciais do veículo', 'editar');
            pushToEditForm(EDIT_ROUTES.differentials.name);
          }}
        />
      </ResumeTitleWrapper>
      {currentAd && !itensDescricao ? (
        <BodyWrapper>
          <Body size="body_2">Você não possui diferenciais adicionados.</Body>
        </BodyWrapper>
      ) : (
        <ResumeVehicleDifferentialsList>
          {itensDescricao?.map(item => (
            <LoadingShimmer show={!currentAd} key={item.id}>
              <InformativeTag>{item.nome}</InformativeTag>
            </LoadingShimmer>
          ))}
        </ResumeVehicleDifferentialsList>
      )}
    </ResumeDifferentialsWrapper>
  );
}
